import "./PaperWalletPanel.scss";
import React, { useState, useEffect } from "react";
import { Card, Row, Col, Button } from "react-bootstrap";
import { getPaperWallet } from "../../actions/setting-action";
import PaperCrossTab from "./PaperCrossTab";
import PaperDepositWithdraw from "./PaperDepositWithdraw";
import PaperIsolatedTab from "./PaperIsolatedTab";
import PaperSpotTab from "./PaperSpotTab";
import PaperTransferModal from "./PaperTransferModal";
import { connect, useSelector } from "react-redux";

import { AccountName, AccountType } from "../../Const";
import { useTranslation } from "react-i18next";
const PaperWalletPanel = (props) => {
  const {t} = useTranslation()
  const { getPaperWallet } = props;
  const [activeTab, setActiveTab] = useState(0);
  const [showDeposit, setShowDeposit] = useState(false);
  const [isDeposit, setIsDeposit] = useState(true);
  const [showTransfer, setShowTransfer] = useState(false);
  const {
    forexCoins,
    total_balance_usd
  } = useSelector((state) => state.settings.paperWallet) || {};
  // useEffect(() => {
  //     getPaperWallet('forex').then(console.log);
  // }, [showDeposit]);

  useEffect(() => {
    getPaperWallet('forex').then(console.log);
  }, [showDeposit]);

  
  const walletTabs = [
    <PaperSpotTab coins={forexCoins}  />,
  ];
  const clickDeposit = () => {
    setShowDeposit(true);
    setIsDeposit(true);
  };
  const clickWithdraw = () => {
    setShowDeposit(true);
    setIsDeposit(false);
  };
  return (
    <div className="paper-wallet round-bg">
      <div>
        <h5>Paper Wallet</h5>
        <Row noGutters className="total-row">
          <Col>
            <div className="title">{t("tb")}</div>
            <div className="value">{total_balance_usd && total_balance_usd.toFixed(6)} USD</div>
          </Col>
          <Col className="btn-col">
            <Button variant="outline-primary" onClick={clickDeposit}>
              {t("ADD")}
            </Button>
          </Col>
          <Col className="btn-col">
            <Button variant="outline-primary" onClick={clickWithdraw}>
            {t("REDUCE")}
            </Button>
          </Col>
          {/* <Col className="btn-col">
            <Button
              variant="outline-primary"
              onClick={() => setShowTransfer(true)}
            >
              {t("TRANSFER")}
            </Button>
          </Col> */}
        </Row>
        <hr />
       
        {walletTabs[activeTab]}
      </div>
      {forexCoins && <PaperDepositWithdraw
        show={showDeposit}
        onHide={() => setShowDeposit(false)}
        isDeposit={isDeposit}
        setIsDeposit={setIsDeposit}
        t={t}
      /> }
      <PaperTransferModal show={showTransfer} onHide={setShowTransfer} />
    </div>
  );
};

export default connect(null, { getPaperWallet })(PaperWalletPanel);
